import { Box } from '@mui/material';
import BrokenImageIcon from '@mui/icons-material/BrokenImage';
import { useState } from 'react';

interface EventPhotoProps {
  photoUrl: string | null;
  size?: 'small' | 'medium' | 'large' | 'full';
  emptyText?: string;
}

const sizeMap = {
  small: { width: 64, height: 36 },
  medium: { width: 128, height: 72 },
  large: { width: 256, height: 144 },
  full: { width: 'auto', height: '100%' },
};

export const EventPhoto = ({ photoUrl, size = 'small', emptyText = '' }: EventPhotoProps) => {
  const [hasError, setHasError] = useState(false);

  if (!photoUrl) {
    return <span>{emptyText}</span>;
  }

  const dimensions = sizeMap[size];
  const isFull = size === 'full';

  if (hasError) {
    return (
      <Box
        sx={{
          width: isFull
            ? '100%'
            : {
                xs: (dimensions.width as number) * 0.75,
                sm: dimensions.width,
              },
          height: isFull
            ? 200
            : {
                xs: (dimensions.height as number) * 0.75,
                sm: dimensions.height,
              },
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          borderRadius: 1,
          border: '1px solid',
          borderColor: 'divider',
          bgcolor: 'action.hover',
        }}
      >
        <BrokenImageIcon
          sx={{
            fontSize: isFull ? 64 : (dimensions.width as number) * 0.5,
            color: 'text.secondary',
          }}
        />
      </Box>
    );
  }

  return (
    <Box
      component="img"
      src={photoUrl}
      alt="Event photo"
      onError={() => setHasError(true)}
      sx={{
        width: isFull
          ? dimensions.width
          : {
              xs: (dimensions.width as number) * 0.75,
              sm: dimensions.width,
            },
        height: isFull
          ? dimensions.height
          : {
              xs: (dimensions.height as number) * 0.75,
              sm: dimensions.height,
            },
        objectFit: isFull ? 'contain' : 'cover',
        borderRadius: 1,
        border: '1px solid',
        borderColor: 'divider',
      }}
    />
  );
};
